import React, { lazy, Suspense, } from 'react';
import PropTypes from 'prop-types';
import { loadRemote, getEnvFromHostname, } from './utils';
import '../View.css';

const BrowserLoggingUi = lazy(
  async () => {
    const component = await loadRemote();
    return {
      default: component,
    };
  }
);

const ActivityLogs = (props) => {
  if (!props.token) {
    return (
      <div>Error: not logged in or can’t find token.</div>
    );
  }

  return (
    <div className="content">
      <Suspense fallback={<div>Loading...</div>}>
        <BrowserLoggingUi
          token={props.token}
          env={getEnvFromHostname()}
        />
      </Suspense>
    </div>
  );
};

ActivityLogs.propTypes = {
  token: PropTypes.shape({}).isRequired,
};

export default ActivityLogs;
